module.exports = __webpack_public_path__ + "static/img/github_icon.032f294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github_icon.png
// module id = dOCo
// module chunks = 0